import * as defaultConfig from './default';

export const configuration = defaultConfig;
